<template>
  <v-stepper v-model="e1" class="password-stepper create-account-stepper">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
        Step 1
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" color="#708AA7"> Step 2 </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <!-- Step 1 -->
      <v-stepper-content step="1">
        <v-card class="deposit-form create-account-form" color="transparent">
          <v-form ref="step1Form" v-model="step1Valid">
            <v-row dense>
              <!-- Bank Name -->
              <v-col cols="12">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-text-field
                    v-model="bankInfo.bank_name"
                    label="Enter Bank Name"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Bank Account Name -->
              <v-col cols="12">
                <fieldset>
                  <legend>Bank Account Name</legend>
                  <v-text-field
                    v-model="bankInfo.bank_acc_name"
                    label="Bank Account Name"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Account No -->
              <v-col cols="12">
                <fieldset>
                  <legend>Account No</legend>
                  <v-text-field
                    v-model="bankInfo.bank_acc_num"
                    label="Account No"
                    single-line
                    solo
                    class="custom-select"
                    :rules="[rules.required, rules.numeric]"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Optional Fields -->
              <v-col cols="12">
                <fieldset>
                  <legend>IBAN Number</legend>
                  <v-text-field
                    v-model="bankInfo.bank_iban_num"
                    label="IBAN Number"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field
                    v-model="bankInfo.ifsc_code"
                    label="IFSC Code"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12">
                <fieldset>
                  <legend>Bank Swift Code</legend>
                  <v-text-field
                    v-model="bankInfo.bank_swift_num"
                    label="Bank Swift Code"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>

              <!-- Next Step Button -->
              <v-col cols="12">
                <v-btn
                  class="text-capitalize btn-account"
                  color="greenMain"
                  tile
                  elevation="0"
                  @click="goToStep2"
                >
                  Next Step
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-stepper-content>

      <!-- Step 2 -->
      <v-stepper-content step="2">
        <v-card class="deposit-form password-field create-account-form" color="transparent">
          <v-row dense>
            <v-col cols="12">
              <fieldset>
                <legend>Bank Country</legend>
                <v-select
                  v-model="bankInfo.bank_residence_country"
                  :items="countries"
                  item-text="name"
                  item-value="id"
                  @change="onCountryChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>State Province</legend>
                <v-select
                  v-model="bankInfo.bank_residence_state"
                  :items="states"
                  item-text="name"
                  item-value="id"
                  @change="onStateChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>City</legend>
                <v-select
                  v-model="bankInfo.bank_residence_city"
                  :items="cities"
                  item-text="name"
                  item-value="id"
                  @change="onCityChange"
                  solo
                  append-icon="mdi-chevron-down"
                  label="Select One"
                  class="custom-select"
                  hide-details
                ></v-select>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>Postal Code</legend>
                <v-text-field
                  v-model="bankInfo.bank_postal_code"
                  label="Enter here"
                  single-line
                  solo
                  hide-details
                  class="custom-select"
                ></v-text-field>
              </fieldset>
            </v-col>

            <v-col cols="12">
              <fieldset>
                <legend>Bank Address</legend>
                <v-text-field
                  v-model="bankInfo.bank_address"
                  label="Enter here"
                  single-line
                  solo
                  hide-details
                  class="custom-select"
                ></v-text-field>
              </fieldset>
            </v-col>

            <v-card-actions class="pa-0">
              <v-btn
                class="ma-0 text-capitalize btn-account"
                color="greenMain"
                tile
                width="146px"
                elevation="0"
                @click="handleSubmit"
                :loading="loading"
              >
                Create Account
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  BANK__ACTIONS,
  COUNTRIES__ACTIONS,
  CITIES__ACTIONS,
  STATES__ACTIONS
} from "@/store/action-types";

export default {
  name: "BankForm",
  data() {
    return {
      e1: 1,
      step1Valid: false,
      loading: false,
      bankInfo: {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "",
        bank_swift_num: "",
        ifsc_code: "",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: ""
      },
      rules: {
        required: v => !!v || "This field is required",
        numeric: v =>
          /^[0-9]+$/.test(v) || "Account number must be numeric"
      }
    };
  },
  computed: {
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"])
  },
  methods: {
    ...mapActions("bank", [BANK__ACTIONS.CREATE]),
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),

    async onCountryChange(value) {
      this.bankInfo.bank_residence_country = value;
      this.bankInfo.bank_residence_state = "";
      this.bankInfo.bank_residence_city = "";
      await this[STATES__ACTIONS.STATES](value);
    },

    async onStateChange(value) {
      this.bankInfo.bank_residence_state = value;
      this.bankInfo.bank_residence_city = "";
      await this[CITIES__ACTIONS.CITIES](value);
    },

    onCityChange(value) {
      this.bankInfo.bank_residence_city = value;
    },

    async handleSubmit() {
      this.loading = true;
      try {
        await this[BANK__ACTIONS.CREATE](this.bankInfo);
        this.resetForm();
      } catch (error) {
        console.error("Error creating bank account:", error);
      } finally {
        this.loading = false;
      }
    },

    goToStep2() {
      if (this.$refs.step1Form.validate()) {
        this.e1 = 2;
      }
    },

    resetForm() {
      this.bankInfo = {
        bank_name: "",
        bank_acc_name: "",
        bank_acc_num: "",
        bank_iban_num: "",
        bank_swift_num: "",
        ifsc_code: "",
        bank_postal_code: "",
        bank_residence_country: "",
        bank_residence_state: "",
        bank_residence_city: "",
        bank_address: ""
      };
      this.e1 = 1;
    }
  },
  async mounted() {
    await this[COUNTRIES__ACTIONS.COUNTRIES]();
    if (this.bankInfo.bank_residence_country) {
      await this[STATES__ACTIONS.STATES](this.bankInfo.bank_residence_country);
    }
    if (this.bankInfo.bank_residence_state) {
      await this[CITIES__ACTIONS.CITIES](this.bankInfo.bank_residence_state);
    }
  }
};
</script>
